import type { LayoutService } from '../services/layoutService'
import type {
  Layout,
  LayoutInput,
  ListLayoutsParams,
} from '../types'
import { wireApiClient as client } from './wireApiClient'

export const httpLayoutService: LayoutService = {
  async list(params?: ListLayoutsParams) {
    const { data } = await client.get<Layout[]>('/layouts', { params })
    return data
  },

  async get(id: string) {
    const { data } = await client.get<Layout>(`/layouts/${id}`)
    return data
  },

  async create(input: LayoutInput) {
    const { data } = await client.post<Layout>('/layouts', input)
    return data
  },

  async update(id: string, input: LayoutInput) {
    const { data } = await client.put<Layout>(`/layouts/${id}`, input)
    return data
  },

  async clone(id: string, name?: string) {
    const { data } = await client.post<Layout>(`/layouts/${id}/clone`, { name })
    return data
  },

  async delete(id: string) {
    await client.delete(`/layouts/${id}`)
  },
}
